// Menu Board in de ouderapp (oprichter 1 okt 2026): het echte bord van een tablet live bekijken,
// alleen kijken. Je-vorm, kort, rustig (docs/DESIGN.md §2).
export const appBoardViewNl = {
    title: 'Bord',
    intro: 'Zo staat het bord er nu bij, live. Alleen kijken: tikken doe je op het bord zelf.',
    choose: 'Bord',
    lastSeen: 'Laatst gezien {when}',
    neverSeen: 'Nog niet gezien',
    virtual: 'Virtuele iPad',
    viewOnly: 'Alleen kijken',
    loading: 'Het bord wordt geladen…',
    reconnecting: 'Even opnieuw verbinden…',
    revoked: 'Dit bord is losgekoppeld.',
    failed: 'Het bord laten zien lukte niet.',
    retry: 'Opnieuw proberen',
    frameTitle: 'Bord {name}, alleen kijken',
    parentsOnly: 'Alleen ouders kunnen het bord hier bekijken.',
    emptyTitle: 'Nog geen bord',
    emptyText: 'Koppel een tablet, dan zie je het bord hier.',
    emptyLink: 'Tablet koppelen',
};
//# sourceMappingURL=boardViewApp.nl.js.map